import './UnfollowProjectModal.scss';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'src/modules/common/components/Button';
import { Modal } from 'src/modules/common/components/Modal';
import { ModalBody } from 'src/modules/common/components/ModalBody';
import { ModalFooter } from 'src/modules/common/components/ModalFooter';
import { ModalHeader } from 'src/modules/common/components/ModalHeader';
import { PreserveContent } from 'src/modules/common/components/PreserveContent';
import { ProjectListUnfollowing } from 'src/modules/project-list/types/ProjectUnfollowing';

type Props = {
  data: ProjectListUnfollowing | null;
  onConfirmUnfollow: () => void;
  onClose: () => void;
};

export const UnfollowProjectModal = ({ data, onConfirmUnfollow, onClose }: Props): React.ReactElement => (
  <Modal
    className="bp-project-unfollow"
    opened={data !== null}
    handleClose={onClose}
    size="sm"
  >
    <PreserveContent>
      {
        data && (
          <>
            <ModalHeader
              handleClose={onClose}
              label={(
                <FormattedMessage
                  id="projectList/unfollowModal/label"
                />
              )}
              title={(
                <FormattedMessage
                  id="projectList/unfollowModal/title"
                />
              )}
              danger={true}
            />

            <ModalBody danger={true}>
              <FormattedMessage
                id="projectList/unfollowModal/body"
                values={{ projectName: data.project.data.title }}
              />
            </ModalBody>

            <ModalFooter>
              <Button
                kind="secondary"
                onClick={onClose}
                autoFocus={true}
                size="md"
                fullWidth={true}
                disabled={data.status?.state === 'pending'}
              >
                <FormattedMessage id="projectList/unfollowModal/cancel"/>
              </Button>

              <Button
                disabled={data.status?.state === 'pending'}
                kind="danger"
                onClick={onConfirmUnfollow}
                size="md"
                fullWidth={true}
                loading={data.status?.state === 'pending'}
              >
                <FormattedMessage id="projectList/unfollowModal/leave"/>
              </Button>
            </ModalFooter>
          </>
        )
      }
    </PreserveContent>
  </Modal>
);
